import { defaultAxios, IParams } from './base';

export interface IFetchTotalProductDetail extends IParams {
  preRequestDtlNo?: number;
  requestSeq?: number;
}

export const fetchTotalProductDetail = (params: IFetchTotalProductDetail) => {
  return defaultAxios().post(`/cust/v2/total/product/detail`, params);
};
